export type AppUser = {
    Id: number,
    AzureUserId: string,
    Name: string,
    Email: string,
    DarkMode: boolean,
    ReceiveKitSubmissionEmails: boolean,
    ReceiveKitCompletedEmails: boolean,
}

export function apiModelToAppUser(apiModel: any) {
    return {
        Id: apiModel.id,
        AzureUserId: apiModel.azureUserId,
        Name: apiModel.name,
        Email: apiModel.email,
        DarkMode: apiModel.darkMode,
        ReceiveKitSubmissionEmails: apiModel.receiveKitSubmissionEmails,
        ReceiveKitCompletedEmails: apiModel.receiveKitCompletedEmails,
    } as AppUser;
}
